import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import CommitteeAccountSearchAndTableWidget from '../../../widgets/admin/manage/CommitteeAccountSearchAndTableWidget'
import CommitteeEditDetailWidget from '../../../widgets/admin/manage/CommitteeEditDetailWidget'
import {
  getMasterAccountType,
  deleteMasterAccountType,
} from '../../../redux/actions/masterAccountType'
import scrollToComponent from 'react-scroll-to-component'

export default function ManageCommitteeAccounts() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [editData, setEditData] = useState()
  const [section, setSection] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  useEffect(() => {
    section && editData && scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
  }, [editData, section])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getMasterAccountType()
      console.log('response', response)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnEdit = (rowData) => {
    setEditData(rowData)
  }

  const handleOnRemove = async (rowData) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await deleteMasterAccountType(rowData.id)
      if (response === 200) {
        handleGetSchema()
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnUpdateSuccess = (res) => {
    setEditData()
    setSchema(res)
  }

  if (error) {
    return (
      <SidebarProposal isManagement>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema) {
    return (
      <SidebarProposal isManagement>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }
  {
    schema && console.log('schema', schema)
  }
  return (
    <SidebarProposal isManagement>
      <ContentHeader header={'จัดการบัญชีคณะกรรมการ'} isNotCallApi />

      {schema && (
        <CommitteeAccountSearchAndTableWidget
          schema={schema}
          handleOnEdit={handleOnEdit}
          handleOnRemove={handleOnRemove}
        />
      )}

      <br />

      {editData && (
        <div ref={(section) => setSection(section)}>
          <CommitteeEditDetailWidget
            schema={schema.forms}
            editData={editData}
            onUpdateSuccess={handleOnUpdateSuccess}
          />
        </div>
      )}
      <br />
      <br />
    </SidebarProposal>
  )
}
